import PropTypes from "prop-types";

const MyAccountIcon = ({ color, size }) => {

	const fill = color || "blue";

	const iconStyles = {
		fontSize: size
	};

	return (
		<i className={`bi bi-person text-${fill}`} style={iconStyles} />
	);

};

MyAccountIcon.propTypes = {
	color: PropTypes.string,
	size: PropTypes.string
};

MyAccountIcon.defaultProps = {
	color: "",
	size: "25px"
};

export default MyAccountIcon;
